import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DataObjectSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DataObjectSVG;
